import { TezaurusUpdateApi } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import Tezaurus from '../../model/Tezaurus';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TezaurusUpdateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const updateTezaurus = async (
  tezaurus: Tezaurus,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { status } = await client.updateTezaurus(tezaurus, options);
  return {
    responseCode: status,
  };
};
